






























































































import RegistrationModule, { RegistrationStatus } from '@/store/modules/registration.module';
import Component from 'vue-class-component';
import { EmptyRegistration } from '@/models/registration';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';

@Component
export default class AccountConfirmationView extends Vue {
  registrationModule = getModule(RegistrationModule, this.$store);

  get name() {
    return `${this.registrationModule.registration.firstName} ${this.registrationModule.registration.lastName}`;
  }

  get email() {
    return this.registrationModule.registration.userId;
  }

  get permitId() {
    return this.registrationModule.registration.permitNumber;
  }

  mounted() {
    if (this.registrationModule.registration === EmptyRegistration) {
      this.$router.push('/create-account');
    }
  }

  private goBack() {
    this.$router.push('/create-account');
  }

  private async confirm() {
    await this.registrationModule.requestRegistration();
    if (this.registrationModule.status === RegistrationStatus.Succeeded) {
      this.$router.push('/create-account-success');
    } else {
      this.$router.push('/create-account');
    }
  }
}
